import {
  SET_ACCESS_TOKEN,
  SET_MESSAGE,
  SET_REFRESH_TOKEN,
  UNSET_MESSAGE,
  UPDATE_SECONDS_TO_EXPIRE,

} from "../mutations";
import {
  DISPLAY_MESSAGE,
  HANDLE_LOGIN,
  HIDE_MESSAGE,
  REGISTER_PASSWORD,
  VERIFY_CODE,

} from "../actions";
import {AuthService, RegisterService} from "../../common/api.service";

const state = {
  message: {
    type: 'danger',
    content: '',
    visible: false
  }
}

const mutations = {
  [SET_MESSAGE]: (state, payload) => {
    state.message = payload
  },
  [UNSET_MESSAGE]: (state) => {
    state.message.content = '';
    state.message.visible = false;
  }
}

const getters = {
  message(state) {
    return state.message;
  },
  messageStyle(state) {
    return 'alert-' + state.message.type;
  }
}

const actions = {
  [DISPLAY_MESSAGE](context, payload) {
    payload.message.visible = true;
    context.commit(SET_MESSAGE, payload.message)
  },
  [HIDE_MESSAGE](context) {
    context.commit(UNSET_MESSAGE)
  },
  [VERIFY_CODE](context, payload) {
    const {registration_code} = payload;
    return RegisterService.verify(registration_code).then(
      function (response) {
      })
  },
  [REGISTER_PASSWORD](context, payload) {
    const {registration_code, password, email, survey_hash} = payload;
    return RegisterService.register(registration_code, password, email, survey_hash).then(
      function (response) {
      })
  },
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/home.js